import { Box, Button, Card, Divider, Typography } from '@mui/material';
import { TableComponent } from './TableComponent';
import DownloadIcon from '@mui/icons-material/Download';
import { downloadExcel } from '../utils/downloadExcel';
import { useEffect, useState } from 'react';
import { calculateNpsScore } from '../utils/calculateNpsScore';
import { detractors, promoters } from '../constants/constants';
import { FeedbackTableRow } from './FeedbackTableRow';

export const TLWiseNPSTable = ({ data }) => {
  const [leadWiseNPS, setLeadWiseNPS] = useState([]);
  const [keys, setKeys] = useState([]);
  function calculateLeadsNPS(responses) {
    const leadsNPS = {};
    for (const response of responses) {
      const team_lead = response.team_lead;
      if (response.feedback) {
        if (!leadsNPS[team_lead]) {
          leadsNPS[team_lead] = {
            promoters: 0,
            detractors: 0,
            total: 0,
          };
        }

        if (promoters.includes(response.feedback)) {
          leadsNPS[team_lead].promoters++;
        } else if (detractors.includes(response.feedback)) {
          leadsNPS[team_lead].detractors++;
        }
        leadsNPS[team_lead].total++;
      }
    }
    let leadsArray = [];

    for (const teamLead in leadsNPS) {
      const { promoters, detractors, total } = leadsNPS[teamLead];
      let NPS = calculateNpsScore(promoters, detractors, total);
      NPS = NPS.toFixed(0);
      leadsArray.push({ 'Team Lead': teamLead, NPS });
    }

    return leadsArray;
  }

  useEffect(() => {
    if (data) {
      const tableData = calculateLeadsNPS(data);
      setLeadWiseNPS(calculateLeadsNPS(data));
      const allKeys = Array.from(
        new Set(tableData.flatMap((row) => Object.keys(row)))
      );
      setKeys(allKeys);
    }
  }, [data]);
  return (
    <div className="dark">
      <Card
        variant="outlined"
        sx={{
          boxShadow: 3,
          width: '100%',
          p: '15px',
          background: '#1d2637',
          color: 'white',
          fontFamily: 'Montserrat, serif !important',
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          alignSelf={'flex-end'}
          justifyContent="space-between"
          marginBottom={2}
          marginTop={2}
        >
          <Typography
            variant="overline"
            gutterBottom
            sx={{ color: 'white', fontFamily: 'Montserrat, serif !important' }}
          >
            Team Lead-Wise NPS Data
          </Typography>
        </Box>

        <Divider />
        <Box
          display="flex"
          alignItems="center"
          alignSelf={'flex-end'}
          justifyContent="start"
          marginBottom={2}
          marginTop={2}
        >
          <Button
            variant="outlined"
            color="#e62552"
            onClick={() => downloadExcel(leadWiseNPS, 'tl-wise-nps')}
            startIcon={<DownloadIcon />}
            sx={{ fontFamily: 'Montserrat, serif !important' }}
          >
            Export Team Lead-Wise NPS Data
          </Button>
        </Box>

        <TableComponent page={0} handleChangePage={()=>{}} data={leadWiseNPS}>
          {leadWiseNPS.map((item, index) => {
            return (
              <FeedbackTableRow
                key={index}
                allKeys={keys}
                item={item}
                index={index}
              />
            );
          })}
        </TableComponent>
      </Card>
    </div>
  );
};
